import translationEn from "./locales/en-US.json";
import translationJa from "./locales/ja-JP.json";
import translationZh from "./locales/zh-CN.json";

export { translationEn, translationJa, translationZh };
